import { render } from "./InvoiceView.vue?vue&type=template&id=6c0ba622"
import script from "./InvoiceView.vue?vue&type=script&lang=js"
export * from "./InvoiceView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__